/**
 * 부정 평가 소분류. 이 항목에는 근거 리뷰 문장을 인용하지 않고 라벨과 건수만 노출한다(B2C-463 정책).
 *
 * 부정 신호의 존재는 보여줘야 분석 전체가 신뢰를 얻지만, 병원 상세에 부정 리뷰 원문을
 * 인용하는 것은 병원과의 마찰 요인이라 문장까지는 붙이지 않는다.
 *
 * B2C-462 배치가 감정 구분을 응답으로 내려주면 이 사전은 그 값으로 대체한다.
 */
const NEGATIVE_ANALYSIS_LABELS: ReadonlySet<string> = new Set([
  // 선택 근거 체계
  "불친절·응대 불만 경험",
  "재방문 거부·강한 불만",
  "효과 불만·재발 경험",
  "비용 부담",
  "안내가·결제가 불일치 경험",
  "시술 통증 호소",
  "대기·예약 불편",
  "재생테이프 등 회복기 번거로움",
  // 평가 통계 체계
  "불친절하거나 부정적인 태도",
  "불친절하거나 부주의한 태도",
  "과잉 진료 여부",
  "치료 후 통증 또는 불편함 여부",
  "치료 비용에 대한 부담감",
  "부정적인 재방문/추천 의사",
])

export const isNegativeAnalysisLabel = (minorCategory: string): boolean =>
  NEGATIVE_ANALYSIS_LABELS.has(minorCategory.trim())
